/** Section heading of a compact block: 600 20/26, −.01em. */
export const COMPACT_SECTION_TITLE_CLASS =
  'm-0 text-[20px] font-semibold leading-[26px] tracking-[-0.01em] text-text-primary';

/** Inline brand-colored link with a trailing chevron: 500 14/20. */
export const COMPACT_INLINE_LINK_CLASS =
  'flex cursor-pointer items-center gap-0.5 border-0 bg-transparent p-0 text-[14px] font-medium leading-5 text-action-brand! no-underline! transition-colors duration-[120ms] [font-family:inherit] hover:text-compact-link-hover!';

/**
 * Product grid of the compact blocks: as many 168px+ columns as fit, two on
 * narrow screens, so a short list keeps its card width.
 */
export const COMPACT_PRODUCT_GRID_CLASS =
  'grid grid-cols-[repeat(auto-fill,minmax(min(168px,47%),1fr))] gap-2';

/**
 * The compact grid on a shared page (search results, favorites) that does not
 * set the marketplace text defaults itself, so the cards keep their font.
 */
export const COMPACT_PRODUCT_LIST_CLASS = `${COMPACT_PRODUCT_GRID_CLASS} antialiased [font-family:var(--fontFamily2)] [text-rendering:auto]`;

/** Most cards a single-row compact grid renders on desktop. */
export const COMPACT_ROW_MAX_CARDS = 8;

/**
 * The compact grid kept to one row on desktop: cards that would wrap are
 * hidden, so the row is always full. A row of n 168px cards with 8px gaps
 * needs a container of 176n - 8 px; each rule hides the cards past the
 * column count of the narrower containers. Mobile keeps its two columns.
 */
export const COMPACT_PRODUCT_ROW_CLASS = `${COMPACT_PRODUCT_GRID_CLASS} @container desktop:[&>*:nth-child(n+9)]:hidden desktop:@max-[1400px]:[&>*:nth-child(n+8)]:hidden desktop:@max-[1224px]:[&>*:nth-child(n+7)]:hidden desktop:@max-[1048px]:[&>*:nth-child(n+6)]:hidden desktop:@max-[872px]:[&>*:nth-child(n+5)]:hidden`;
